import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function VideoCall3(props) {
  const blue = getColorValue('illustrationAccent');
  const orange = getColorValue('illustrationOrange');
  const purple = getColorValue('illustrationPurple');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m32 221.65s139.28 16.56 210.96-.75v-172.39s-113.67 27.85-210.96-1.51c0 0 1.54 175.77 0 174.64z"
        fill={blue}
      />
      <path
        d="m170.141 133.781c.04 2.64-.14 5.14-.53 7.5-2.33 14.18-12.06 23.05-25.84 25.49-2.35.41-4.81.64-7.38.68-2.68.04-5.25-.14-7.7-.51-13.85-2.12-23.8-10.7-26.52-24.73-.46-2.34-.71-4.84-.75-7.48-.04-2.68.15-5.22.55-7.6 2.35-14.12 12.05-22.96 25.82-25.45 2.44-.45 5-.69 7.68-.73 2.57-.03 5.04.13 7.4.48 13.83 2.06 23.78 10.65 26.52 24.77.46 2.37.71 4.9.75 7.58z"
        fill={orange}
      />
      <path
        d="m136.52 173.131c33.02-.57 55.19 14.51 56.65 54.51-37.01 2.34-78.36.72-109.9102-1.43 2.42-37.6 23.1502-52.56 53.2602-53.08z"
        fill={orange}
      />
      <path
        d="m189.33 71.6309h31.3v8.4455l9.2-4.9758.02.01v19.19l-.02.01-9.2-4.981v8.5513h-31.3z"
        fill={purple}
      />
      <path
        d="m220.62 80.0801-8.54 4.62 8.54 4.63z"
        fill={illustrationColors.staticDarkBlue}
      />
    </svg>
  );
}

export default VideoCall3;
